export default "__VITE_ASSET__TfUf6Yjv__"